import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {StepCounterEngineProvider} from "../../providers/step-counter-engine/step-counter-engine";
import {InitStepCounterPage} from "../init-step-counter/init-step-counter";

/**
 * Generated class for the AppStepCounterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-step-counter',
  templateUrl: 'app-step-counter.html',
})
export class AppStepCounterPage extends InitStepCounterPage {


}



// WEBPACK FOOTER //
// ./src/pages/app-step-counter/app-step-counter.ts